module.exports = __webpack_public_path__ + "media/images/front/team/silvia_miguel-9caf2d6a40767d13f48bf72f9ab09363.jpg";